import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const WarningIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M12 18.5v-2h-2v2h2ZM12 15.111V9h-2v6.111h2Z" />
    <path fillRule="evenodd" d="m11 0 11 22H0L11 0Zm7.764 20H3.236L11 4.472 18.764 20Z" />
  </IconWrapper>
)

export default WarningIconMedium
